import { FilterSelectedValue } from '../hooks/filters/interfaces/filter-selected-value.interface';

const HEADER_KEYS = 'x-filters';
const clearFilterSelection = (
  filterSelection: FilterSelectedValue[] | undefined,
) => {
  if (filterSelection) {
    return filterSelection.filter((i) => i.values && i.values.length > 0);
  }
};
export const filterHeaderInterceptor = (config: any) => {
  if (config.data === undefined) return config;
  const { filterSelection } = config.data;
  if (filterSelection !== undefined) {
    const cleanFilterSelection = clearFilterSelection(filterSelection);
    config.headers[HEADER_KEYS] = JSON.stringify(cleanFilterSelection);
  }
  return config;
};
